import {
    AUTHOR_AI_PLATFORM,
    PRODUCT_FEEDBACK_CHATBOT_DETAILS,
    PRODUCT_FEEDBACK_SELECTED_PRODUCT,
} from '../../common/actionTypes';

const INITIAL_STATE = {
    pfchatbotDetails: null,
    pfselectedProduct: null,
    authorAiPlatform:null,
    // serachFilter: null,
    // logsReviewPaginationTake: null,
    // logsReviewPaginationPage: 1,
    // logsReviewTotalPageCount: 0,
    // logsReviewTotalQueryCount: 0,
    // logsReviewTableData: null,
    // logsReviewChartData: null,
    // logsReviewTableLoading: true,
    // logsReviewQueryId: null,
    // responseConversationStep: null,
};

const productFeedbackReducer = (state = INITIAL_STATE, action) => {
    if (action.type === undefined) {
        return state;
    }
    switch (action.type) {
        case PRODUCT_FEEDBACK_CHATBOT_DETAILS: {
            return {
                ...state,
                pfchatbotDetails: action.payload,
            };
        }
        case PRODUCT_FEEDBACK_SELECTED_PRODUCT: {
            return {
                ...state,
                pfselectedProduct: action.payload,
            };
        }
        case AUTHOR_AI_PLATFORM: {
            return {
                ...state,
                authorAiPlatform: action.payload,
            };
        }
        // case SEARCH_FILTER: {
        // 	return {
        // 		...state,
        // 		serachFilter: action.payload,
        // 	};
        // }
        // case LOGS_REVIEW_PAGINATION_TAKE: {
        // 	return {
        // 		...state,
        // 		logsReviewPaginationTake: action.payload,
        // 	};
        // }
        // case LOGS_REVIEW_PAGINATION_PAGE: {
        // 	return {
        // 		...state,
        // 		logsReviewPaginationPage: action.payload,
        // 	};
        // }
        // case TOTAL_PAGE_COUNT: {
        // 	return {
        // 		...state,
        // 		logsReviewTotalPageCount: action.payload,
        // 	};
        // }
        // case LOGS_REVIEW_TOTAL_QUERY_COUNT: {
        // 	return {
        // 		...state,
        // 		logsReviewTotalQueryCount: action.payload,
        // 	};
        // }
        // case LOGS_REVIEW_TABLE_DATA: {
        // 	return {
        // 		...state,
        // 		logsReviewTableData: action.payload,
        // 	};
        // }
        // case LOGS_REVIEW_CHART_DATA: {
        // 	return {
        // 		...state,
        // 		logsReviewChartData: action.payload,
        // 	};
        // }
        // case LOGS_REVIEW_TABLE_LOADING: {
        // 	return {
        // 		...state,
        // 		logsReviewTableLoading: action.payload,
        // 	};
        // }
        // case LOGS_REVIEW_QUERY_ID: {
        // 	return {
        // 		...state,
        // 		logsReviewQueryId: action.payload,
        // 	};
        // }
        // case RESPONSE_CONVERSATION_STEP: {
        // 	return {
        // 		...state,
        // 		responseConversationStep: action.payload,
        // 	};
        // }
        default:
            return state;
    }
};

export default productFeedbackReducer;
